let timelineElements = [

    {
        id: 1,
        title: "Graduate Student - Northeastern University",
        location: "Boston,MA",
        description:
            "Masters in Information Systems specaiizing in Software Engineering",
        //buttonText: "View Frontend Projects",
        icon: "school",
    },
    {
        id: 2,
        title: "KeelWorks",
        location: "Boston,MA",
        description:
            "Developed and maintained KeelCompass, a workforce engagement platform, building React/TypeScript frontend features and Spring Boot backend services with automated CI/CD deployments on AWS.",
        //buttonText: "View Frontend Projects",
        date: "November 2024 - September 2025",
        icon: "work",
    },

    {
        id: 3,
        title: "Capgemini | Consultant(Full stack Software Developer)",
        location: "Banaglore, India",
        description:
            "Elevated organizational data processing capabilities through a revolutionary approach, leading the architectural design of scalable microservices. Spearheaded the implementation of an efficient CI/CD pipeline, significantly reducing deployment times to mere minutes. Additionally, played a pivotal role in boosting sales by empowering teams with dynamic React solutions",
        //buttonText: "Company Website",
        date: "July 2020 - August 2022",
        icon: "work",
    }



];

export default timelineElements;
